import * as React from "react";
import { Context } from "./_context";
export const PinchIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.602 12.505a1 1 0 0 1 .898.995V20h-2v-4.086l-6.293 6.293-1.414-1.414L8.086 14.5H4v-2h6.5l.102.005Zm11.605-9.298L15.914 9.5H20v2h-6.5l-.103-.005a1 1 0 0 1-.897-.995V4h2v4.086l6.293-6.293 1.414 1.414Z", fill: "currentColor" }));
  return iconset[size];
};
PinchIcon.iconId = "1iujN1";
